module.exports = __webpack_public_path__ + "img/phone-community.04fe1ad1.webp";